export const NUMBERS = Array.from({ length: 10 }, (_, i) => i);
export const MAX_PIN_LENGTH = 6;


// Shuffles an array using Fisher-Yates algorithm
export const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};


export const handleNumberInput = (currentPin, num, maxLength = MAX_PIN_LENGTH) => {
  if (currentPin.length >= maxLength) return currentPin;
  return currentPin + num.toString();
};


export const clearPin = () => "";


export const isValidPin = (pin, requiredLength = MAX_PIN_LENGTH) => {
  return pin.length === requiredLength;
};

export const pinStatusCheck = (navigate) => {
  const pstatus = localStorage.getItem("__ps");

  if (pstatus === "true") {
    return navigate("/login-pin");
  }

  if (pstatus === "false") {
    return navigate("/register-pin");
  }

  navigate("/");
};

